import styled from "styled-components";

export const NameTxt = styled.div`
  width: 100%;
  margin-top: 0;
  padding-top: 0;
  font-size: 1.8rem;
  font-weight: bold;
  @media (min-width: 900px) {
    margin-top: 1rem;
    width: 80%;
  }
`;
